<template>
  <div class="zhuanti">
    <div class="width1000 margintb container">
      <div class="title_left">
        <div class="text">
          {{dataList.mainTitle}}
        </div>
      </div>
      <div class="banner">
        <div class="swiperDiv">
          <swiper :options="swiperOption"
                  ref="mySwiper">
            <swiper-slide v-for="(item,index) in dataList.data"
                          :key="index">
              <div class="banner-item">
                <div class="context">
                  <div v-if="item.dataType=='article'">
                    <a :href="'/h5/detail.html?artId='+item.dataVal"
                       target="_blank ">
                      <img :src="item.imgUrl"
                           class="img" />
                    </a>
                    <a :href="'/h5/detail.html?artId='+item.dataVal"
                       target="_blank "
                       class="titleA">
                      <h3>{{item.title}}</h3>
                    </a>

                    <p>
                      <span class="mark">{{item.description}}</span>
                      <a :href="'/h5/detail.html?artId='+item.dataVal"
                         target="_blank ">
                        <span :href="item.url"
                              class="read"
                              target="_blank ">［阅读］</span>
                      </a>
                    </p>
                  </div>
                  <div v-else>
                    <a :href="item.dataVal"
                       target="_blank "><img :src="item.imgUrl"
                           class="img" /></a>
                    <a :href="item.dataVal"
                       class="titleA"
                       target="_blank ">
                      <h3>{{item.title}}</h3>
                    </a>

                    <p>
                      <span class="mark">{{item.description}}</span>
                      <a :href="item.dataVal"
                         target="_blank ">
                        <span class="read">［阅读］</span>
                      </a>
                    </p>
                  </div>
                </div>

              </div>
            </swiper-slide>

          </swiper>
        </div>

        <div class="swiper-button-prev"
             slot="button-prev"></div>
        <div class="swiper-button-next"
             slot="button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      newData: {},
      swiperOption: {
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        slidesPerView: 3,
        spaceBetween: 0,
        autoplay: 3000,
        // loop: true
      }

    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  props: ['dataList'],
  mounted () {
    //console.log(this.dataList.data);
  },
  methods: {

  },
  watch: {
    dataList () {

    }
  }
}
</script>
<style lang="less">
.zhuanti {
  .titleA:hover {
    color: #e60012;
  }
  .swiper-container {
    margin: 0 5px;
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    background-image: url('../../assets/images/left-arrow.png');
    left: 3px;
    background-size: 30px 30px;
    top: 100px;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url('../../assets/images/right-arrow.png');
    right: 3px;
    background-size: 30px 30px;
    top: 100px;
  }
  .el-carousel__arrow--right {
    right: 4px;
  }
  .el-carousel__arrow--left {
    left: 4px;
  }
  .container {
    position: relative;
    background: #f5f5f5;
    overflow: hidden;
    .title_left {
      width: 60px;
      background: #e60012;
      color: #fff;
      text-align: center;
      min-height: 280px;
      display: flex;
      justify-content: center;
      align-items: center;
      .text {
        display: inline-block;
        font-size: 26px;
        font-weight: bold;
        padding: 0 30px;
        line-height: 34px;
        font-family: 'Microsoft YaHei';
      }
    }
    .banner {
      width: 940px;
      background: #f5f5f5;
      position: absolute;
      top: 0;
      left: 60px;
      .swiperDiv {
        width: 890px;
        margin-left: 25px;
      }
      .banner-item {
        margin-top: 15px;
        float: left;
        width: 100%;
        padding-bottom: 15px;
        .context {
          width: 93%;
          margin: 0 auto;
          .read {
            color: #e60012;
          }
          // .mark {
          //   display: inline-block;
          //   max-height: 36px;
          //   overflow: hidden;
          //   display: -webkit-box;
          //   text-overflow: ellipsis;
          //   -webkit-line-clamp: 2;
          //   -webkit-box-orient: vertical;
          // }
        }
        .img {
          width: 100%;
          height: 150px;
          // display: block;
          // margin: 0 auto;
        }
        h3 {
          font-size: 14px;
          padding: 8px 0;
        }
      }
    }
  }
}
</style>
